<template>
	<div class="cropper-container">
		<div class="cropper-content">
			<div class="cropper-box">
				<div class="cropper-edit">
					<vue-cropper ref="cropper" :img="option.img" :outputSize="option.outputSize"
						:outputType="option.outputType" :info="option.info" :canScale="option.canScale"
						:autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth"
						:autoCropHeight="option.autoCropHeight" :fixed="option.fixed" :fixedNumber="option.fixedNumber"
						:full="option.full" :fixedBox="option.fixedBox" :canMove="option.canMove"
						:canMoveBox="option.canMoveBox" :original="option.original" :centerBox="option.centerBox"
						:height="option.height" :infoTrue="option.infoTrue" :maxImgSize="option.maxImgSize"
						:enlarge="option.enlarge" :mode="option.mode" @realTime="realTime" @imgLoad="imgLoad">
					</vue-cropper>
				</div>
				<!--底部操作工具按钮-->
				<div class="cropper-footer">
					<span class="cropper-footer_item" @click="changeScale(1)">
						<a-icon type="plus" />
						<span>放大</span>
					</span>
					<span class="cropper-footer_item" @click="changeScale(-1)">
						<a-icon type="minus" />
						<span>缩小</span>
					</span>
					<span class="cropper-footer_item" @click="rotateLeft">
						<svg-icon iconClass="leftRotate" />
						<span>左旋</span>
					</span>
					<span class="cropper-footer_item" @click="rotateRight">
						<svg-icon iconClass="rightRotate" />
						<span>右旋</span>
					</span>
					<span class="cropper-footer_item" @click="resetHandle">
						<svg-icon iconClass="reset" />
						<span>重置</span>
					</span>
					<!-- <a-button icon="plus" @click="changeScale(1)">放大</a-button>
				<a-button icon="minus" @click="changeScale(-1)">缩小</a-button>
				<a-button @click="rotateLeft">左旋转</a-button>
				<a-button @click="rotateRight">右旋转</a-button>
				<a-button icon="reload">重置</a-button> -->
				</div>
			</div>
			<!--预览效果图-->
			<div class="cropper-preview">
				<div :style="previews.div" class="cropper-preview_content">
					<img :src="previews.url" :style="previews.img">
				</div>
			</div>
		</div>
		<a-button class="cropper-submit" type="primary" @click="uploadImg"
			:loading="loading">确认</a-button>
	</div>
</template>
 
<script>
import { VueCropper } from "vue-cropper"
import MediaService from "@/api/mediaService"
import { loadImage } from "@/utils"
export default {
  name: "CropperImage",
  components: {
    VueCropper
  },
  props: {
    imageUrl: {
      type: String,
      default: ""
    },
    klassId: {
      type: String,
      default: ""
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      name: this.Name,
      previews: {},
      option: {
        img: this.imageUrl, //裁剪图片的地址
        outputSize: 1, //裁剪生成图片的质量(可选0.1 - 1)
        outputType: "png", //裁剪生成图片的格式（jpeg || png || webp）
        info: false, //图片大小信息
        canScale: true, //图片是否允许滚轮缩放
        autoCrop: true, //是否默认生成截图框
        autoCropWidth: 230, //默认生成截图框宽度
        autoCropHeight: 150, //默认生成截图框高度
        fixed: true, //是否开启截图框宽高固定比例
        fixedNumber: [1.53, 1], //截图框的宽高比例
        full: true, //false按原比例裁切图片，不失真
        fixedBox: true, //固定截图框大小，不允许改变
        canMove: true, //上传图片是否可以移动
        canMoveBox: true, //截图框能否拖动
        original: false, //上传图片按照原始比例渲染
        centerBox: false, //截图框是否被限制在图片里面
        height: true, //是否按照设备的dpr 输出等比例图片
        infoTrue: false, //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000, //限制图片最大宽度和高度
        enlarge: 1 //图片根据截图框输出比例倍数
        // mode: '230px 150px'  //图片默认渲染方式
      },
      loading: false,
      disabledCropper: true
    }
  },
  watch: {
    imageUrl: {
      handler(value) {
        if (value) {
          this.option.fixedNumber = [this.scale, 1]
          this.option.autoCropHeight = this.option.autoCropWidth / this.scale
          this.option.img = value
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //初始化函数
    imgLoad(msg) {
      console.log("工具初始化函数=====" + msg)
    },
    //图片缩放
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
      this.disabledCropper = false
    },
    //向左旋转
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
      this.disabledCropper = false
    },
    //向右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight()
      this.disabledCropper = false
    },
    //实时预览函数
    realTime(data) {
      this.previews = data
      console.log("vvvvvvvv", data.w)
      this.disabledCropper = data.w === 0
    },
    resetHandle() {
      this.$refs.cropper.refresh()
      this.disabledCropper = true
    },
    //上传图片
    uploadImg() {
      //获取截图的blob数据
      this.loading = true
      const _this = this
      this.$refs.cropper.getCropBlob(data => {
        const params = { file_name: `${new Date().getTime()}.png`, content_type: "image/png", klass_id: this.klassId }
        //调用axios上传
        MediaService.createMediaService(params)
          .then(media => {
            var xhr = new XMLHttpRequest()
            xhr.open("PUT", media.upload_url, true)
            xhr.onload = function() {
              MediaService.uploadMediaService({ mediaId: media.id })
                .then(res => {
                  _this.$message.success("上传成功，请等待图片加载")
                  console.time("图片加载时间")
                  loadImage(res.thumbnail_url).then(() => {
                    console.timeEnd("图片加载时间")
                  })
                  _this.loading = false
                  _this.$emit("cropperHandle", res)
                })
                .catch(() => {
                  _this.$message.error("上传异常，请重新操作")
                  _this.loading = false
                })
            }
            xhr.onerror = () => {
              _this.$message.error("上传异常，请重新操作")
            }
            xhr.send(data) /* file 是要上传的文件对象 */
          })
          .catch(() => {
            _this.loading = false
            _this.$message.error("上传异常，请重新操作")
          })
      })
    }
  }
}
</script>
 
<style lang="less" scoped>
.cropper {
  &-container {
  }

  &-content {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
  }

  &-box {
    flex: 1;
    width: 100%;
  }

  &-edit {
    width: auto;
    height: 300px;
  }

  &-footer {
    margin-top: 30px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;

    &_item {
      display: flex;
      flex-flow: nowrap column;
      color: rgb(90, 123, 178);
      cursor: pointer;
      align-items: center;
    }
  }

  &-submit {
    display: block;
    width: 300px;
    margin: 60px auto;
  }

  &-preview {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;

    &_content {
      overflow: hidden;
      border: 1px solid #67c23a;
      background: #cccccc;
    }
  }
}
</style>
